export default "__VITE_ASSET__DMobm6rI__"